import uniqid from 'uniqid'
import { Form } from 'react-bootstrap'
import { IFilterCheckBox } from '../../types'

export const FilterCheckBox = (props: IFilterCheckBox) => {
	const {
		attr,
		value,
		setValue,
		label,
		styles = {},
		isDisabled = false,
	} = props
	const key = uniqid()
	//TODO: logic for usage in Filters if necessary
	return (
		<div className="filter-input-cont" style={styles}>
			{label ? <Form.Label className="text-dark" htmlFor={`input-${key}`}>{label}</Form.Label> : null}

			<div className={'form-check'}>
				<input
					type="checkbox"
					id={`input-${key}`}
					className="form-check-input"
					{...attr}
					disabled={isDisabled}
					checked={value ?? false}
					onChange={(event) => {
						//console.log('FilterCheckBox onChange: ', {event})
						setValue(event.target.checked)
					}}
				/>
			</div>
		</div>
	)
}